import { axiosClient } from '../../../library/Service/axiosClient';

/**
 * Top 5 engaged users per institute.
 * Backend reads from DynamoDB all_activity_logs (broadcast microservice)
 * and resolves names from MySQL alumni_profile_snapshot (internal-admin-reports).
 */

const BASE = () => `${process.env.REACT_APP_BROADCAST_SERVER}/vibrancy`;

export interface EngagedUser {
    rank: number;
    studentId: string;
    name: string;
    passOutYear?: string | number;
    activityCount: number;
}

export interface ActivityCounts {
    current: number;
    previous: number;
}

export const VibrancyEngagementService = {
    /**
     * Top 5 by all-time activity count for the institute.
     * scope=overall → no date filter applied on the backend.
     */
    getTopOverall: (instituteId: string | number) =>
        axiosClient().get<{ data: EngagedUser[] }>(`${BASE()}/top-engaged`, {
            params: { institute_id: instituteId, scope: 'overall' },
        }),

    /**
     * Top 5 by activity count within the given period.
     * period: 'monthly' | 'quarterly' | 'halfyearly' | 'yearly'
     * Backend applies event_date range filter (handles both YYYY-MM-DD and DD-MM-YYYY).
     */
    getTopByPeriod: (instituteId: string | number, period: string) =>
        axiosClient().get<{ data: EngagedUser[] }>(`${BASE()}/top-engaged`, {
            params: { institute_id: instituteId, scope: 'period', period },
        }),

    getActivityCounts: (instituteId: string | number, period: string) =>
        axiosClient().get<{ success: boolean; data: ActivityCounts }>(`${BASE()}/activity-counts`, {
            params: { institute_id: instituteId, period },
        }),
};
